import React from 'react';
import './Header.css'; // Import the CSS file here

const Header = () => {
  return (
    <header className="header">
        <img src="./IAD_logo.png" alt="IAD Logo"/>
        <h1>FASA Web Demo</h1>
        <img src="./University_at_Buffalo_logo.svg.png" alt="University at Buffalo Logo" />
    </header>
  );
}

export default Header;